import React, { useEffect, useMemo, useState } from 'react'
import { customStyle } from '../../Components/Style'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import "../../Assets/Css/AddEmployee.scss"
import Select from 'react-select'
import axios from 'axios'
import { getDepartments } from '../../Services/Department/action';
import { getDesignations } from '../../Services/Designation/action';
import { addUsers, getUsers, updateUsers } from '../../Services/Users/action';
import { connect } from 'react-redux';
import OpenEye from '../../Assets/Images/Employee/OpenEye.svg'
import CloseEye from '../../Assets/Images/Employee/CloseEye.svg'
import { toast } from 'react-toastify';
// const Department = [
//     { value: "Director", label: "Director" },
//     { value: "Team Lead", label: "Team Lead" },
//     { value: "HR", label: "HR" },
//     { value: "Designing", label: "Designing" },
//     { value: "Development", label: "Development" },
// ];

const Gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
];

const EmployeeType = [
    { value: "Full Time", label: "Full Time" },
    { value: "Part Time", label: "Part Time" },
    { value: "On Contract", label: "On Contract" },
    { value: "Internship", label: "Internship" },
    { value: "Trainee", label: "Trainee" },
    { value: "Ex-Employee", label: "Ex-Employee" },
];

const MaritalStatus = [
    { value: "Married", label: "Married" },
    { value: "UnMarried", label: "UnMarried" },
];

const AddEmployee = (props) => {
    const location = useLocation();
    const employeeData = location?.state?.data?.allData;
    // const [countries, setCountries] = useState([]);
    // const [selectedCountry, setSelectedCountry] = useState(null);
    const [filteredDesignations, setFilteredDesignations] = useState([]);
    const [filteredDepartments, setFilteredDepartments] = useState([]);

    const fetchData = async () => {
        const options = {
            module: 'employees',
            id: props?.user?.role?.name === "employee" ? props?.user?.id : null
        };
        await props?.getDepartmentList();
        await props?.getDesignationList();
        await props?.getUsers(options)
    }
    useEffect(() => {
        fetchData();
    }, []);

    const Department = props?.department?.map((item) => {
        return {
            value: item?.name,
            label: item?.name
        }
    })

    const Designation = props?.designation?.map((item) => {
        return {
            value: item?.name,
            label: item?.name
        }
    })

    // useEffect(() => {
    //     const fetchCountries = async () => {
    //         try {
    //             const response = await axios.get('https://restcountries.com/v3.1/all');
    //             const countryOptions = response.data.map(country => ({
    //                 value: country.cca2,
    //                 label: country.name.common
    //             }));
    //             setCountries(countryOptions);

    //             if (employeeData?.country) {
    //                 const matchedCountry = countryOptions.find(
    //                     (c) => c.label === employeeData.country
    //                 );
    //                 setSelectedCountry(matchedCountry || null);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching country data:', error);
    //         }
    //     };

    //     fetchCountries();
    // }, [employeeData?.country]);
    const [name, setName] = useState(employeeData?.name || "");
    const [employee_code, setEmployeeCode] = useState(employeeData?.employee_code || "")
    const [email, setEmail] = useState(employeeData?.email || "");
    const [permanentAddress, setPermanentAddress] = useState(employeeData?.permanent_address || "");
    const [address, setAddress] = useState(employeeData?.address || "");
    const [mobile, setMobile] = useState(employeeData?.mobile || "");
    // const [language, setLanguage] = useState(employeeData?.language || "");
    const [emergency_contact, setEmergencyContact] = useState(employeeData?.emergency_contact || "");
    const [emergency_contact_relationship, setEmergencyContactRelationship] = useState(employeeData?.emergency_contact_relationship || "");
    const [emergency_contact_name, setEmergencyContactName] = useState(employeeData?.emergency_contact_name || "");
    const [skills, setSkills] = useState(employeeData?.skills || "");
    const [slack_id, setSlackId] = useState(employeeData?.slack_id || "");
    const [aniversary, setmrgAniversary] = useState(employeeData?.marriage_anniversary_date ? new Date(employeeData?.marriage_anniversary_date) : null);
    const [department, setDepartment] = useState(Department.find((d) => d.value === employeeData?.department?.name) || "");
    const [designation, setDesignation] = useState(Designation.find((d) => d.value === employeeData?.designation?.name) || "");
    const [gender, setGender] = useState(Gender.find((d) => d.value === employeeData?.gender) || "");
    const [employeeType, setEmployeeType] = useState(EmployeeType.find((d) => d.value === employeeData?.employee_type) || "");
    const [maritalStatus, setMaritalStatus] = useState(MaritalStatus.find((d) => d.value?.toLowerCase() === employeeData?.marital_status?.toLowerCase()) || "");
    const [joiningDate, setJoiningDate] = useState(
        employeeData?.joining_date ? new Date(employeeData?.joining_date) : null);
    const [noticePeriodStartDate, setNoticePeriodStartDate] = useState(
        employeeData?.notice_period_start_date ? new Date(employeeData?.notice_period_start_date) : null);
    const [noticePeriodEndDate, setNoticePeriodEndDate] = useState(
        employeeData?.notice_period_end_date ? new Date(employeeData?.notice_period_end_date) : null);
    const [probationPeriodEndDate, setProbationPeriodEndDate] = useState(
        employeeData?.probation_period_end_date ? new Date(employeeData?.probation_period_end_date) : null);
    const [dob, setDob] = useState(
        employeeData?.date_of_birth ? new Date(employeeData?.date_of_birth) : null);
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false);
    const [personalEmail, setPersonalEmail] = useState(
        employeeData?.personal_email || ""
    );
    const navigate = useNavigate();

    const isInternSelected = () => {
        return department?.value?.toLowerCase() === 'intern' || designation?.value?.toLowerCase() === 'intern';
    };

    const initialValues = useMemo(() => ({
        name: employeeData?.name || "",
        employee_code: employeeData?.employee_code || "",
        email: employeeData?.email || "",
        permanentAddress: employeeData?.permanent_address || "",
        address: employeeData?.address || "",
        mobile: employeeData?.mobile || "",
        emergency_contact: employeeData?.emergency_contact || "",
        emergency_contact_relationship: employeeData?.emergency_contact_relationship || "",
        emergency_contact_name: employeeData?.emergency_contact_name || "",
        skills: employeeData?.skills || "",
        slack_id: employeeData?.slack_id || "",
        aniversary: employeeData?.marriage_anniversary_date ? new Date(employeeData?.marriage_anniversary_date) : null,
        department: Department.find((d) => d.value === employeeData?.department?.name) || "",
        designation: Designation.find((d) => d.value === employeeData?.designation?.name) || "",
        gender: Gender.find((d) => d.value === employeeData?.gender) || "",
        employeeType: EmployeeType.find((d) => d.value === employeeData?.employee_type) || "",
        maritalStatus: MaritalStatus.find((d) => d.value?.toLowerCase() === employeeData?.marital_status?.toLowerCase()) || "",
        joiningDate: employeeData?.joining_date ? new Date(employeeData?.joining_date) : null,
        noticePeriodStartDate: employeeData?.notice_period_start_date ? new Date(employeeData?.notice_period_start_date) : null,
        noticePeriodEndDate: employeeData?.notice_period_end_date ? new Date(employeeData?.notice_period_end_date) : null,
        probationPeriodEndDate: employeeData?.probation_period_end_date ? new Date(employeeData?.probation_period_end_date) : null,
        dob: employeeData?.date_of_birth ? new Date(employeeData?.date_of_birth) : null,
        password: employeeData?.password || '',
        showPassword: false,
        personalEmail: employeeData?.personal_email || '',
    }), [employeeData]);

    const isSameDate = (a, b) => {
        if (!a && !b) return true;
        if (!a || !b) return false;
        return new Date(a).getTime() === new Date(b).getTime();
    };

    const isFormChanged = useMemo(() => {
        return (
            initialValues?.name != name ||
            initialValues?.employee_code != employee_code ||
            initialValues?.email != email ||
            initialValues?.permanentAddress != permanentAddress ||
            initialValues?.address != address ||
            initialValues?.mobile != mobile ||
            initialValues?.emergency_contact != emergency_contact ||
            initialValues?.emergency_contact_relationship != emergency_contact_relationship ||
            initialValues?.emergency_contact_name != emergency_contact_name ||
            initialValues?.skills != skills ||
            initialValues?.slack_id != slack_id ||
            !isSameDate(initialValues?.aniversary, aniversary) ||
            initialValues?.department?.value != department?.value ||
            initialValues?.designation?.value != designation?.value ||
            initialValues?.gender?.value != gender?.value ||
            initialValues?.employeeType?.value != employeeType?.value ||
            initialValues?.maritalStatus?.value != maritalStatus?.value ||
            !isSameDate(initialValues?.joiningDate, joiningDate) ||
            !isSameDate(initialValues?.noticePeriodStartDate, noticePeriodStartDate) ||
            !isSameDate(initialValues?.noticePeriodEndDate, noticePeriodEndDate) ||
            !isSameDate(initialValues?.probationPeriodEndDate, probationPeriodEndDate) ||
            !isSameDate(initialValues?.dob, dob) ||
            initialValues?.password != password ||
            initialValues?.personalEmail != personalEmail
        );
    }, [
        name, employee_code, email, permanentAddress, address, mobile, emergency_contact, emergency_contact_relationship, emergency_contact_name, skills, slack_id, aniversary, department, designation, gender, employeeType, maritalStatus, joiningDate, noticePeriodStartDate, noticePeriodEndDate, probationPeriodEndDate, dob, password, showPassword, personalEmail, initialValues
    ]);

    const validatePassword = (password) => {
        if (password.length < 6) {
            return "Password must be at least 6 characters";
        }

        if (!/(?=.*[a-z])/.test(password)) {
            return "Password must contain at least one lowercase letter";
        }

        if (!/(?=.*[A-Z])/.test(password)) {
            return "Password must contain at least one uppercase letter";
        }

        if (!/(?=.*\d)/.test(password)) {
            return "Password must contain at least one number";
        }

        if (!/(?=.*[@$!%*?&])/.test(password)) {
            return "Password must contain at least one special character (@$!%*?&)";
        }

        return null; // No error
    };
    const validateForm = () => {
        const isIntern = isInternSelected();
        const isNewEmployee = !employeeData;

        if (!isIntern && (!isNewEmployee && !password && password !== '')) {
            toast.error("Please fill all the required fields");
            return false;
        }
        if (isNewEmployee && (!password || password.trim() === '')) {
            toast.error("Password is required for new employees");
            return false;
        }
        if (!name || !employee_code || !department || !designation || !gender || !employeeType || !joiningDate) {
            toast.error("Please fill all the required fields");
            return false;
        }

        if ((!personalEmail || personalEmail.trim() === '') && (!email || email.trim() === '')) {
            toast.error('Please provide at least one email: Company or Personal');
            return false;
        }
        if (password && password.trim() !== '') {
            const passwordError = validatePassword(password);
            if (passwordError) {
                toast.error(passwordError);
                return false;
            }
        }

        return true;
    };

    const handleNavigate = async () => {
        if (!validateForm()) {
            return;
        }

        const emailExists = props?.users?.some((item) =>
            item.email === email && item.id !== employeeData?.id
        );
        const employeeCodeExists = props?.users?.some((item) =>
            item.employee_code === employee_code && item.id !== employeeData?.id
        );

        if (employeeCodeExists) {
            toast.error('Employee code is already exist');
            return;
        }
        if (emailExists) {
            toast.error('Company email already in use');
            return;
        }
        if (personalEmail && email && personalEmail.trim() === email.trim()) {
            toast.error('Personal Email and Company Email must not be the same');
            return false;
        }
        try {
            let body = {
                name,
                email,
                permanent_address: permanentAddress,
                address,
                mobile,
                // language,
                employee_code,
                emergency_contact,
                emergency_contact_relationship,
                emergency_contact_name,
                skills,
                slack_id,
                marriage_anniversary_date: aniversary,
                designation_id: props?.designation?.find((item) => item?.name === designation?.value)?.id,
                // country: selectedCountry?.label,
                department_id: props?.department?.find((item) => item?.name === department?.value)?.id,
                gender: gender?.value,
                employee_type: employeeType?.value,
                marital_status: maritalStatus?.value,
                joining_date: joiningDate,
                work_anniversary_date: joiningDate,
                notice_period_start_date: noticePeriodStartDate,
                notice_period_end_date: noticePeriodEndDate,
                probation_period_end_date: probationPeriodEndDate,
                date_of_birth: dob,
                password,
                personal_email: personalEmail,
            };
            if (password && password.trim() !== '') {
                body.password = password;
            }
            if (email && email.trim() !== '') {
                body.email = email;
            }

            if (employeeData) {
                body.updateLocalStorage = false;
                await props.updateUser(employeeData?.id, body);
            }
            else {
                const addUserres = await props.addUser(body);
            }
            navigate('/employees');
        } catch (error) {
            console.error("Error in adding users (employees):", error)
        }
    }

    const changeVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    useEffect(() => {
        if (department?.value && props?.department) {
            const selectedDept = props.department.find(d => d.name === department.value);
            if (selectedDept?.designations) {
                setFilteredDesignations(selectedDept.designations.map(item => ({
                    value: item.name,
                    label: item.name
                })));
            } else {
                setFilteredDesignations(Designation);
            }
        } else {
            setFilteredDesignations(Designation);
        }
    }, [department, props?.department]);
    useEffect(() => {
        if (designation?.value && props?.designation) {
            const selectedDesig = props.designation.find(d => d.name === designation.value);
            if (selectedDesig?.departments) {
                setFilteredDepartments(selectedDesig.departments.map(item => ({
                    value: item.name,
                    label: item.name
                })));
            } else {
                setFilteredDepartments(Department);
            }
        } else {
            setFilteredDepartments(Department);
        }
    }, [designation, props?.designation]);
    return (
        <div className="add-employee-main">
            <div className="page-title">
                <h4>{employeeData ? 'Edit' : 'Add'} Employee</h4>
                <div className="edit-btn">
                    <button className="custom-btn" onClick={() => navigate('/employees')}>
                        Cancel
                    </button>
                    <button className="custom-btn save" onClick={handleNavigate} disabled={!isFormChanged}>
                        {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Save"}
                    </button>
                </div>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="common-cards">
                            <div className="custom-row">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Employee Code <span style={{ color: 'red' }}>*</span></h6>
                                            <input type="text" className="input-css" name='fullname' value={employee_code} onChange={(e) => setEmployeeCode(e.target.value)} placeholder='Employee Code' />
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="input-group">
                                            <h6 className='label'>Full Name <span className='required-field'> *</span></h6>
                                            <input type="text" className="input-css" name='fullname' value={name} onChange={(e) => setName(e.target.value)} placeholder='Full Name' />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Personal Email</h6>
                                            <input
                                                type="email"
                                                className="input-css"
                                                name='personalEmail'
                                                value={personalEmail}
                                                onChange={(e) => setPersonalEmail(e.target.value)}
                                                placeholder='Personal Email'
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Company Email</h6>
                                            <input type="email" className="input-css" name='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email' />
                                        </div>
                                    </div>


                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Company Password {!employeeData && <span style={{ color: 'red' }}>*</span>}</h6>
                                            <div className='password'>
                                                <input className="input-css" type={showPassword ? "text" : "password"} name="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password' />
                                                <label htmlFor="text">
                                                    <button className='label-btn'>
                                                        <img src={showPassword ? CloseEye : OpenEye} alt="password-show" onClick={changeVisibility} />
                                                    </button>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Skills</h6>
                                            <input type="text" className="input-css" name='maritalStatus' value={skills} onChange={(e) => setSkills(e.target.value)} placeholder="Skills" />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Department <span className='required-field'> *</span></h6>
                                            <Select
                                                options={filteredDepartments}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={department}
                                                onChange={(val) => {
                                                    setDepartment(val)
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Designation <span className='required-field'> *</span></h6>
                                            <Select
                                                options={filteredDesignations}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={designation}
                                                onChange={(val) => {
                                                    setDesignation(val)
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Mobile Number</h6>
                                            <input type="text" className="input-css" name='mobilenumber' value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder='Mobile Number' />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Gender <span className='required-field'> *</span></h6>
                                            <Select
                                                options={Gender}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={gender}
                                                onChange={(val) => {
                                                    setGender(val)
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'> Permanent address</h6>
                                            <input type="text" className="input-css" name='address' value={permanentAddress} onChange={(e) => setPermanentAddress(e.target.value)} placeholder='Address' />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Address</h6>
                                            <input type="text" className="input-css" name='address' value={address} onChange={(e) => setAddress(e.target.value)} placeholder='Address' />
                                        </div>
                                    </div>

                                    {/* <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Language</h6>
                                            <input type="text" className="input-css" name='language' value={language} onChange={(e) => setLanguage(e.target.value)} placeholder='Language' />
                                        </div>
                                    </div> */}


                                    {/* <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Country</h6>
                                            <Select
                                                options={countries}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={selectedCountry}
                                                onChange={(val) => {
                                                    setSelectedCountry(val);
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div> */}


                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Marital Status</h6>
                                            <Select
                                                options={MaritalStatus}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={maritalStatus}
                                                onChange={(val) => {
                                                    setMaritalStatus(val)
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    {maritalStatus?.value === "Married" ? (
                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Marriage Anniversary</h6>
                                                <DatePicker
                                                    selected={aniversary}
                                                    onChange={(date) => setmrgAniversary(date)}
                                                    dateFormat="dd-MM-yyyy"
                                                    name="transaction_date"
                                                    placeholderText="Marriage Anniversary"
                                                    className="w-full p-2 border rounded bg-white text-black"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="col-lg-4">
                                            <div className="input-group invisible">
                                                <h6 className='label'>Marriage Anniversary</h6>
                                                <input
                                                    type="text"
                                                    disabled
                                                    className="w-full p-2 border rounded bg-transparent"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Date Of Birth</h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={dob}
                                                onChange={(date) => {
                                                    setDob(date);
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                placeholderText="Date"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Employee Type <span className='required-field'> *</span></h6>
                                            <Select
                                                options={EmployeeType}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={employeeType}
                                                onChange={(val) => {
                                                    setEmployeeType(val)
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Joining Date <span className='required-field'> *</span></h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={joiningDate}
                                                onChange={(date) => {
                                                    setJoiningDate(date);
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                placeholderText='Date'
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Probation Period End Date</h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={probationPeriodEndDate}
                                                onChange={(date) => {
                                                    setProbationPeriodEndDate(date);
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                placeholderText="Date"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Notice Period Start Date</h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={noticePeriodStartDate}
                                                onChange={(date) => {
                                                    setNoticePeriodStartDate(date);
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                placeholderText="Date"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Notice Period End Date</h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={noticePeriodEndDate}
                                                onChange={(date) => {
                                                    setNoticePeriodEndDate(date);
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                placeholderText="Date"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Slack ID</h6>
                                            <input type="text" className="input-css" name='slack_id' value={slack_id} onChange={(e) => setSlackId(e.target.value)} placeholder='Slack ID' />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Emergency Contact</h6>
                                            <input type="number" className="input-css" name='emergency-contact' value={emergency_contact} onChange={(e) => setEmergencyContact(e.target.value)} placeholder='Emergency Contact' />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Relation with Emergency Contact</h6>
                                            <input type="text" className="input-css" name='emergency-contact' value={emergency_contact_relationship} onChange={(e) => setEmergencyContactRelationship(e.target.value)} placeholder='Emergency Contact Realtionship' />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Name of Emergency Contact</h6>
                                            <input type="text" className="input-css" name='emergency-contact' value={emergency_contact_name} onChange={(e) => setEmergencyContactName(e.target.value)} placeholder='Emergency Contact Name' />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const mapStateToProps = (state) => {
    return {
        loading: state.userReducer.loading,
        designation: state.designationReducer.designation,
        department: state.departmentReducer.department,
        users: state.userReducer.users,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        addUser: (data) => {
            dispatch(addUsers(data));
        },
        getDesignationList: () => {
            dispatch(getDesignations())
        },
        getDepartmentList: () => {
            dispatch(getDepartments())
        },
        updateUser: (id, data) => {
            dispatch(updateUsers(id, data));
        },
        getUsers: (options) => {
            dispatch(getUsers(options))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEmployee);